import { render } from "./ExperimentTag.vue?vue&type=template&id=0164045d&scoped=true&ts=true"
import script from "./ExperimentTag.vue?vue&type=script&lang=ts"
export * from "./ExperimentTag.vue?vue&type=script&lang=ts"

import "./ExperimentTag.vue?vue&type=style&index=0&id=0164045d&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0164045d"]])

export default __exports__